import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment.development";
import { LoginResponse, RegisterPayload } from "../interfaces/user.interface";

export interface CreateCustomerDto {
  customerName: string;
  phoneNumber: string;
  gender: string;
  dob: string;
  area: string;
  city: string;
  state: string;
  pinCode: string;
  aadhaar: string;
  pan: string;
  plan: number;
  amount: number;
}

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private baseURL = environment.apiUrl;

  constructor(private httpClient: HttpClient) {}

  loginMe(email: string, password: string) {
    return this.httpClient.post<LoginResponse>(
      `${this.baseURL}/account/login`,
      {
        email,
        password,
      }
    );
  }

  createCustomerAccount(payload: CreateCustomerDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseURL}/admin/accounts`, payload);
  }

  searchCustomers(searchDto: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.baseURL}/customers/search`,
      searchDto
    );
  }

  getCustomerChitDetails(id: number): Observable<any> {
    return this.httpClient.get<any>(
      `${this.baseURL}/admin/accounts/${id}/chitplans`
    );
  }

  resetPassword(payload: RegisterPayload): Observable<any> {
   return this.httpClient.post<any>(`${this.baseURL}/account/reset`, payload);
  }
}
